import "./css/login.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import axios from "axios";
const cookies = new Cookies();

const AdminLogin = () => {
  const [user_id, setUserId] = useState("");
  const navigate = useNavigate();
  const userIdChange = (event) => {
    setUserId(event.target.value);
  };

  const [password, setPassword] = useState("");

  const passwordChange = (event) => {
    setPassword(event.target.value);
  };
  const onCheckEnter = (e) => {
    if(e.key === 'Enter') {
      onLogin();
    }
  }
  useEffect(() => {
    let login_attempt = cookies.get('login_attempt');
    if (login_attempt === undefined){
      cookies.set('login_attempt', Number(0), { maxAge: 3600 * 1000, sameSite: true });
    }
    let isloggedIn = sessionStorage.getItem("isloggedIn");
    if (isloggedIn === null) {
      console.log(isloggedIn);
      isloggedIn = cookies.get("isloggedIn");
      if (isloggedIn === "true") {
        navigate("/board");
      }
    }
    if (isloggedIn === "true") {
      navigate("/board");
    }
  }, []);

  async function onLogin(e) {
    let login_attempt = cookies.get('login_attempt');
    console.log(login_attempt);
    if (login_attempt>4){
      alert("로그인 시도 4번을 초과하였습니다. 1시간 후에 다시 시도해주십시오");
      return false;
    }
    cookies.set('login_attempt', Number(login_attempt)+1);
    

    const data = {
      user_id: user_id,
      password: password,
    };
    if (user_id.length === 0) {
      alert("아이디를 입력해주세요");
      return;
    }
    if (password.length === 0) {
      alert("비밀번호를 입력해주세요");
      return;
    }

    axios
      .post("https://thegmmedical.com:5002/api/login", data, {
        withCredentials: true,
        credentials: "include", // Now this is was the missing piece in the client side
      })
      .then((res) => {
        window.location = "/"; //log in 버튼 누르면 -> redirect -> (logged) main 페이지
      })
      .catch((error) => {
        alert("로그인에 실패하였습니다.");
      });
  }

  /*onSilentRefresh = () => {
        axios.post('/silent-refresh', data)
            .then(onLoginSuccess)
            .catch(error => {
                // ... 로그인 실패 처리
            });
    }
    
    onLoginSuccess = response => {
        const { accessToken } = response.data;
    
        // accessToken 설정
        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    
        // accessToken 만료하기 1분 전에 로그인 연장
        setTimeout(onSilentRefresh, JWT_EXPIRRY_TIME - 60000);
    }*/

  return (
    <div className="wrap">
      <div
        className="sub_header"
        style={{
          height: "200px",
          background: "rgb(38,58,83)",
          background:
            "linear-gradient(90deg, rgba(38,58,83,1) 0%, rgba(65,86,113,1) 50%, rgba(81,102,129,1) 100%)",
        }}
      ></div>
      <form onKeyPress={onCheckEnter}>
      <div className="login">
        <h2 className="headerTxt">관리자 로그인</h2>

        <div className="loginForm">
          <div className="user_id">
            <input
              text="user_id"
              id="user_id"
              placeholder="아이디를 입력해주세요"
              onChange={userIdChange}
              value={user_id}
            />
            <br />
          </div>
          <div className="password">
            <input
              text="password"
              id="password"
              type="password"
              placeholder="비밀번호를 입력해주세요"
              onChange={passwordChange}
              value={password}
            />
            <br />
          </div>
          <div className="div_button">
            <div className="btn-st2" onClick={onLogin}>
              LOGIN
            </div>
          </div>
        </div>
      </div>
      </form>
    </div>
  );
};

export default AdminLogin;
